<template>
    <div>
        <h6 class="heading-small text-muted mb-4">เซลล์ผู้ดูแลคุณ</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        ชื่อเซลล์
                    </label>
                    <template v-if="$USER_LOGIN.get().isShippop">
                        <v-select    
                            label="name"
                            :options="personal.listSale"
                            v-model="personal.saleName"
                            @input="selectedSaleSupport"
                        >
                        </v-select>
                    </template>
                    <template v-else>
                        <input
                            :disabled="true"
                            type="text"
                            class="form-control"
                            placeholder="ชื่อเซลล์"
                            v-model="personal.saleName"
                        />
                    </template>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        เบอร์ติดต่อเซลล์
                    </label>
                    <input
                        :disabled="true"
                        type="text"
                        class="form-control"
                        placeholder="เบอร์ติดต่อเซลล์"
                        v-model="personal.saleTel"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        LINE ID เซลล์
                    </label>
                    <input
                        :disabled="true"
                        type="text"
                        class="form-control"
                        placeholder="LINE ID เซลล์"
                        v-model="personal.saleIdLine"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        personal: Object
    },
    methods: {
        selectedSaleSupport(data) {
            this.personal.saleId = data.id;
            this.personal.saleName = data.name;
            this.personal.saleTel = data.tel;
            this.personal.saleIdLine = data.line_id;
        },
    },
}

</script>